<script setup>
const $q = useQuasar()
const props = defineProps({
  hideInfoOnMobile: {
    type: Boolean,
    default: false,
    required: false,
  },
})
</script>

<template>
  <div class="row full-width q-pl-sm q-pl-md-md bordered-footer">
    <div class="col-auto" v-if="!$q.screen.lt.md">
      <div class="row">
        <div class="col-auto q-pr-md">
          <div class="row">
            <div class="col-12 small-text q-item__label--caption">
              <slot name="footer-info-top-left"></slot>
            </div>
          </div>
          <div class="row">
            <div class="col-12 small-text q-item__label--caption">
              <slot name="footer-info-bottom-left"></slot>
            </div>
          </div>
        </div>
        <div class="col-auto">
          <div class="row">
            <div class="col-12 small-text q-item__label--caption">
              <slot name="footer-info-top-right"></slot>
            </div>
          </div>
          <div class="row">
            <div class="col-12 small-text q-item__label--caption">
              <slot name="footer-info-bottom-right"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :class="{ 'col-12': $q.screen.lt.md, 'col column items-end': !$q.screen.lt.md }">
      <div class="row inline no-wrap justify-end" :class="{ 'full-width': $q.screen.lt.md }">
        <slot name="footer-buttons"></slot>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
